export enum BIUserEntry {
  BIZMNGR = 'bizmngr',
  SITE = 'site',
  EDITOR = 'editor',
}
